/**
 * api集成管理
 */
import Vue from 'vue'
import axios from 'axios'
import { CONSOLE_HOST, API_HOST, QUERY_HOST, setParams } from '../config/config'
import querystring from 'querystring'
// import qs from 'qs';


export default {
    /**
     * 通用api方法
     */
    apiCommunication(apiname, param, cb, errcb) {
        var params = param;
        let host = CONSOLE_HOST;
        // console.debug("apiCommunication> host:%o, apiname:%o, param:%o, cb:%o, errcb:%o", API_HOST, apiname, param, cb, errcb);

        // console.debug("apiCommunication> CONSOLE_HOST:%o, API_HOST:%o, QUERY_HOST:%o", CONSOLE_HOST, API_HOST, QUERY_HOST);
        if(apiname){
            let apinameArr = apiname.split('/');
            apinameArr = apinameArr.filter(t => t!=undefined && t!==null && t!=='');
            let arrlen = apinameArr.length;
            // console.debug("apiCommunication> apinameArr:%o, arrlen:%o", apinameArr, arrlen);


            if((apinameArr[0] === 'news' && apinameArr[1] === 'query')){
                host = QUERY_HOST
                params = setParams(param)
                // console.debug("apiCommunication> host:%o, params:%o", host, params)
            }
            else{
                if( (apinameArr[1] === 'news' || apinameArr[1] === 'console' || apinameArr[1] === 'label' || apinameArr[1] === 'console' || (apinameArr[1] === 'user' && apinameArr[2] !== 'login')) ){
                    params = setParams(param)
                    // console.debug("apiCommunication> host:%o, params:%o", host, params)
                }else if( apinameArr[1] === 'press' ){
                    host = API_HOST
                    // console.debug("apiCommunication> host:%o, params:%o", host, params)

                }
            }
        }

        // axios.post(host + apiname, querystring.stringify(params)).then(function(response) {
        //         console.debug("apiCommunication> response:%o", response);
        //         cb(response);
        // }).catch(function(err){
        //     console.log("apiCommunication> err:%o", err);
        //     errcb(err);
        // });

        axios.post(host + apiname, querystring.stringify(params))
        .then(
            response => {
                // console.debug("apiCommunication> response:%o", response);
                // if(response.code === 0){
                    // console.debug("apiCommunication> ok response:%o", response);
                    if(typeof(cb) === 'function'){
                        cb(response);
                    }
                // }
                // else{
                //     console.log("apiCommunication> error response:%o", response);
                //     if(typeof(errcb) === 'function'){
                //         errcb(response)
                //     }
                // }
        })
        // .catch(function(err){
        //     console.log("apiCommunication> err:%o", err);
        //     if(typeof(errcb) === 'function'){
        //         errcb(err);
        //     }
        // });

    }
}

/**
 * news接口列表
 *
 * /api/news/add  新增新闻
 * /api/news/list  新闻列表
 * /api/news/edit  新闻更新
 * /api/news/transfer  新闻状态转换
 */

/**
 * 通用接口列表
 *
 * /api/user/login  用户登录
 */



// WEBPACK FOOTER //
// ./src/api/api.js